import { createResource, For, Show, type Component } from "solid-js";
import { Sparkles } from "lucide-solid";
import { api, type Snip } from "../lib/api";
import SnipCard from "../components/SnipCard";
import Spinner from "../components/Spinner";

async function fetchLatest(): Promise<Snip[]> {
  const { data, error } = await api.GET("/snips", { params: { query: { limit: 30 } } });
  if (error) throw new Error("Gönderiler yüklenemedi");
  return data ?? [];
}

const Home: Component = () => {
  const [snips] = createResource(fetchLatest);

  return (
    <div class="mx-auto max-w-3xl px-4 py-6">
      <div class="mb-5 flex items-center gap-2">
        <Sparkles size={20} class="text-primary" />
        <h1 class="m-0 text-lg font-semibold">En Son Paylaşılanlar</h1>
      </div>

      <Show
        when={!snips.loading}
        fallback={
          <div class="flex justify-center py-16">
            <Spinner size={28} />
          </div>
        }
      >
        <Show
          when={(snips() ?? []).length > 0}
          fallback={
            <div class="rounded-xl border border-border bg-card p-8 text-center text-muted-foreground">
              Henüz gönderi yok. İlk snip'i sen paylaş!
            </div>
          }
        >
          <div class="flex flex-col gap-3">
            <For each={snips()}>{(snip) => <SnipCard snip={snip} />}</For>
          </div>
        </Show>
      </Show>
    </div>
  );
};

export default Home;
